import React from "react"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import { Link } from "gatsby"
import Nav from "./Nav"
import HeaderCountdown from "./HeaderCountdown"
import ContainerMax from "components/shared/ContainerMax"
import Logo from "components/shared/Logo"
import logo2 from "images/WTA_500.png"

const NavBarWrap = styled.div`
	height: 60px;
	display: flex;
	align-items: center;
	position: relative;
	transition: background-color .4s ease;
	@media ${media.sm} {
		height: 80px;
	}
	@media ${media.md} {
		height: 100px;
	}
	@media ${media.lg} {
		border-bottom: solid 10px ${props => props.theme.colors.primary};
		${props => props.navActive && css`
			border-bottom: solid 10px ${props => props.theme.colors.white};
	`}
	}

	&:after {
		@media ${media.lg} {
			content: "";
			position: absolute;
			top: 100%;
			height: 25px;
			width: 100%;
			background-image: linear-gradient(to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, 0));
		}
		
		
		${props => props.navActive && css`
		display: none;
		`}
	}
`

const ContainerMaxStyled = styled(ContainerMax)`
	height: 100%;
	position: relative;
`

const NavBarToggle = styled.button`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	background-color: transparent;
	border: 0;
	width: 30px;
	height: 25px;
	display: flex;
	flex-wrap: wrap;
	left: 1rem;
	padding: 0;

	@media ${media.lg} {
		left: auto;
		right: 30px;
		justify-content: flex-end;
	}

	span {
		position: absolute;
		height: 2px;
		width: 100%;
		background-color: ${props => props.theme.colors.white};
		left: 0;
		@media ${media.lg} {
			right: 0;
			left: auto;
		}
		
		&:nth-child(1) {
			top: 0;
		}
		
		&:nth-child(2) {
			top: 50%;
			width: 20px;
			transform: translateY(-50%);
		}
		
		&:nth-child(3) {
			bottom: 0;
			width: 15px;
		}
	}

	${props => props.navActive && css`
	span {
		background-color: ${props => props.theme.colors.white};
		&:nth-child(1) {
			top: 50%;
			left: 50%;
			right: auto;
			transform: translate(-50%, -50%) rotate(-45deg);
		}
		
		&:nth-child(2) {
			opacity: 0;
		}
		
		&:nth-child(3) {
			top: 50%;
			width: 100%;
			left: 50%;
			right: auto;
			bottom: auto;
			transform: translate(-50%, -50%) rotate(45deg);
		}
	}
	`}
`

const LogoWrap = styled(Link)`
	position: absolute;
	top: 50%;
	left: 50%;
	/* width: 100%; */
	transform: translate(-50%, -50%);
	text-align: center;

	img {
		width: 300px;
		height: 58px;
		/* max-height: 69px; */
		max-height: 100%;

		@media ${media.md} {
			/* max-width: 350px; */
			/* max-height: 90px; */

		}
		@media ${media.lg} {
			/* max-width: 375px; */
		}
		@media ${media.xxl} {
			/* max-width: 400px; */
		}
	}

	@media ${media.sm} {
		width: auto;
		text-align: left;
	}
`

const WtaLogo = styled.img`
	width: 60px;
	position: absolute;
	right: 1rem;
	top: 50%;
	transform: translateY(-50%);

	@media ${media.sm} {
		width: 75px;
	}

	@media ${media.lg} {
		right: 5rem;
	}

	@media (min-width: 1300px) {
		left: 1rem;
	}

	@media (min-width: 1650px) {
		left: 0;
	}
`

const NavBar = (props) => {
	const toggleNavLogo = () => {
		if(props.navActive) {
			// document.body.classList.toggle('nav-active')
			props.toggleNav()
		}
	}

	return (
		<NavBarWrap navActive={props.navActive}>
			<ContainerMaxStyled maxWidth="1600">
				<HeaderCountdown navActive={props.navActive} />

				<LogoWrap to="/" onClick={toggleNavLogo}>
					<Logo />
				</LogoWrap>
				
				<Nav 
					path={props.path} 
					navActive={props.navActive}
				/>

				<WtaLogo src={logo2} alt="WTA 500" />
				
				<NavBarToggle 
					onClick={props.toggleNav}
					navActive={props.navActive}
				>
					<span></span>
					<span></span>
					<span></span>
				</NavBarToggle>
			</ContainerMaxStyled>
		</NavBarWrap>
	)
}

export default NavBar